import { render, staticRenderFns } from "./CreateBadgeTask.vue?vue&type=template&id=5fd68ac4&"
import script from "./CreateBadgeTask.vue?vue&type=script&lang=js&"
export * from "./CreateBadgeTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports